AFRAME.registerComponent('news-graph-settings-panel', {
    init: function () {
        this.render = this.render.bind(this);
        this.updateRotationLabel = this.updateRotationLabel.bind(this);
        this.render();

        this.el.sceneEl.addEventListener('news-graph-autorotate-changed', this.updateRotationLabel);
        this.el.sceneEl.addEventListener('theme-changed', this.render);
    },

    remove: function () {
        this.el.sceneEl.removeEventListener('news-graph-autorotate-changed', this.updateRotationLabel);
        this.el.sceneEl.removeEventListener('theme-changed', this.render);
    },

    _isLightMode: function() {
        if (typeof getCacheItem === 'function') {
            const settings = getCacheItem('mainSettings');
            if (settings && settings.themeMode) {
                return settings.themeMode === 'Light';
            }
        }
        return false;
    },

    updateRotationLabel: function () {
        if (!this.rotateBtn) return;
        const wrapper = document.getElementById('news-graph-wrapper');
        const rotationComp = wrapper && wrapper.components['news-graph-rotation'];
        const autoRotateEnabled = rotationComp && typeof rotationComp.isAutoRotateEnabled === 'function'
            ? rotationComp.isAutoRotateEnabled()
            : true;

        this.rotateBtn.setAttribute('ui-button', 'label', autoRotateEnabled ? 'Stop Rotation' : 'Start Rotation');
        this.rotateBtn.setAttribute('ui-button', 'colorScheme', autoRotateEnabled ? 'accent' : 'primary');
    },

    createToggle: function (id, x, label, isActive, onToggle) {
        const isLight = this._isLightMode();
        const textColor = isLight ? '#111827' : '#ffffff';
        const capsuleColor = isLight ? '#000000' : '#ffffff';
        const activeColor = isLight ? '#3636E3' : '#ffffff';
        const inactiveColor = isLight ? '#737373' : '#4f4f4f';

        const container = document.createElement('a-entity');
        container.setAttribute('id', id);
        container.setAttribute('position', `${x} 0 0.01`);

        const text = document.createElement('a-troika-text');
        text.setAttribute('value', label);
        text.setAttribute('font-size', 0.035);
        text.setAttribute('color', textColor);
        text.setAttribute('align', 'left');
        text.setAttribute('anchor', 'left');
        text.setAttribute('position', '-0.13 0 0.005');
        container.appendChild(text);

        const toggleBg = document.createElement('a-rounded-plane');
        toggleBg.setAttribute('position', '0.03 -0.01 0.005');
        toggleBg.setAttribute('color', capsuleColor);
        toggleBg.setAttribute('opacity', 0.15);
        toggleBg.setAttribute('height', 0.03);
        toggleBg.setAttribute('width', 0.08);
        toggleBg.setAttribute('radius', 0.008);
        container.appendChild(toggleBg);

        const knob = document.createElement('a-rounded-plane');
        knob.setAttribute('position', `${isActive ? 0.07 : 0.03} -0.015 0.01`);
        knob.setAttribute('width', 0.04);
        knob.setAttribute('height', 0.04);
        knob.setAttribute('radius', 0.004);
        knob.setAttribute('color', isActive ? activeColor : inactiveColor);
        container.appendChild(knob);

        const clickArea = document.createElement('a-plane');
        clickArea.setAttribute('width', 0.32);
        clickArea.setAttribute('height', 0.12);
        clickArea.setAttribute('opacity', 0);
        clickArea.setAttribute('data-raycastable', '');
        clickArea.setAttribute('position', '0 0 0.015');
        clickArea.addEventListener('click', () => {
            isActive = !isActive;
            knob.setAttribute('position', `${isActive ? 0.07 : 0.03} -0.015 0.01`);
            knob.setAttribute('color', isActive ? activeColor : inactiveColor);
            onToggle(isActive);
        });
        container.appendChild(clickArea);

        return { container, clickArea };
    },

    render: function () {
        this.el.innerHTML = '';

        const isLight = this._isLightMode();
        const panelColor = isLight ? '#F5F5F5' : '#111';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 1.15);
        bg.setAttribute('height', 0.22);
        bg.setAttribute('position', '-0.575 -0.11 0');
        bg.setAttribute('color', panelColor);
        bg.setAttribute('opacity', 1.0);
        bg.setAttribute('radius', 0.025);
        this.el.appendChild(bg);

        const rotateBtn = this.rotateBtn = document.createElement('a-entity');
        rotateBtn.setAttribute('id', 'ng-settings-rotate-btn');
        rotateBtn.setAttribute('data-raycastable', '');
        rotateBtn.setAttribute('position', '-0.35 0 0.01');
        rotateBtn.setAttribute('ui-button', {
            label: 'Start Rotation',
            width: 0.32,
            height: 0.11,
            depth: 0.015,
            radius: 0.015,
            colorScheme: 'primary',
            type: 'rounded-box',
            preferredFontSize: 0.033
        });
        rotateBtn.addEventListener('click', () => {
            this.el.sceneEl.emit('news-graph-toggle-autorotate');
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_ToggleRotate');
        });
        this.el.appendChild(rotateBtn);

        let isLegendVisible = true;
        const legendPanel = document.getElementById('news-graph-legend-vr');
        if (legendPanel) {
            isLegendVisible = legendPanel.getAttribute('visible') !== false && legendPanel.getAttribute('visible') !== 'false';
        }
        const legendToggle = this.createToggle('ng-settings-legend-toggle', 0.01, 'Legend', isLegendVisible, (visible) => {
            const panel = document.getElementById('news-graph-legend-vr');
            if (panel) {
                panel.setAttribute('visible', visible);
            }
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_ToggleLegend', { visible });
        });
        this.el.appendChild(legendToggle.container);

        let isGlobeVisible = true;
        const newsGraphEl = document.getElementById('news-graph');
        const newsGraphComp = newsGraphEl && newsGraphEl.components['news-graph-vr'];
        if (newsGraphComp && newsGraphComp.orbitSphere) {
            isGlobeVisible = newsGraphComp.orbitSphere.visible !== false;
        }
        const globeToggle = this.createToggle('ng-settings-globe-toggle', 0.37, 'Globe', isGlobeVisible, (visible) => {
            this.el.sceneEl.emit('news-graph-set-globe-visible', { visible });
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_ToggleGlobe', { visible });
        });

        let tooltipEl = null;
        globeToggle.clickArea.addEventListener('mouseenter', () => {
            if (tooltipEl) return;
            tooltipEl = document.createElement('a-entity');
            tooltipEl.setAttribute('position', '0.37 0.11 0.02');
            
            const tooltipBg = document.createElement('a-rounded-plane');
            tooltipBg.setAttribute('width', 0.52);
            tooltipBg.setAttribute('height', 0.06);
            tooltipBg.setAttribute('radius', 0.01);
            tooltipBg.setAttribute('color', '#222');
            tooltipBg.setAttribute('opacity', 0.9);
            tooltipEl.appendChild(tooltipBg);

            const tooltipText = document.createElement('a-troika-text');
            tooltipText.setAttribute('value', 'Show border between narratives and tickers');
            tooltipText.setAttribute('font-size', 0.020);
            tooltipText.setAttribute('align', 'center');
            tooltipText.setAttribute('anchor', 'center');
            tooltipText.setAttribute('color', '#ffffff');
            tooltipText.setAttribute('position', '0.26 0.03 0.005');
            tooltipBg.appendChild(tooltipText);

            this.el.appendChild(tooltipEl);
        });

        globeToggle.clickArea.addEventListener('mouseleave', () => {
            if (tooltipEl) {
                tooltipEl.remove();
                tooltipEl = null;
            }
        });

        this.el.appendChild(globeToggle.container);

        setTimeout(this.updateRotationLabel, 50);
    }
});

export function mountSettingsPanel() {
    let settingsPanel = document.getElementById('news-graph-settings-panel');
    if (!settingsPanel) {
        settingsPanel = document.createElement('a-entity');
        settingsPanel.setAttribute('id', 'news-graph-settings-panel');
        settingsPanel.setAttribute('news-graph-settings-panel', '');
        
        settingsPanel.setAttribute('position', '-0.010 1.06 -1.40');
        settingsPanel.setAttribute('rotation', '0 0 0');
        settingsPanel.setAttribute('scale', '1.05 1.05 1.05');
        
        const sceneWrapper = document.getElementById('scene-wrapper');
        if (sceneWrapper) {
            sceneWrapper.appendChild(settingsPanel);
        } else {
            const scene = document.querySelector('a-scene');
            if (scene) scene.appendChild(settingsPanel);
        }
    }
}

export function unmountSettingsPanel() {
    const settingsPanel = document.getElementById('news-graph-settings-panel');
    if (settingsPanel) {
        settingsPanel.remove();
    }
}
